export const pageTitle =
	'HostJane Web Hosting | Managed Secure Cloud & VPS Hosting Platform';
export const pageDescription =
	"Cloud Hosting and Virtual Private Servers from HostJane - Host business websites, dynamic websites, blogs, WordPress, WooCommerce and applications.";
